import { toast, ToastContentParams, ToastVariant, ToastOptions } from '@redis-ui/components';

export const showToast = (
  content: string | ToastContentParams,
  variant: ToastVariant = 'danger',
  options?: ToastOptions
) => toast(content, { variant, ...options });
